"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowDataWithMaxCountsForVirtualConnectionWithTagFilter = exports.getRowDataWithMaxCountsForVirtualConnection = void 0;
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
function getRowDataWithMaxCountsForVirtualConnection(database, resultData) {
    return Object.assign(Object.assign({}, database), { contentType: 'virtualConnection', maxDownstreamDatasources: (0, data_catalog_shared_1.getMaxDownstreamDatasources)(resultData), maxDownstreamWorkbooks: (0, data_catalog_shared_1.getMaxDownstreamWorkbooks)(resultData) });
}
exports.getRowDataWithMaxCountsForVirtualConnection = getRowDataWithMaxCountsForVirtualConnection;
function getRowDataWithMaxCountsForVirtualConnectionWithTagFilter(database, resultData) {
    const tag = resultData && resultData.tags && resultData.tags[0];
    return getRowDataWithMaxCountsForVirtualConnection(database, tag);
}
exports.getRowDataWithMaxCountsForVirtualConnectionWithTagFilter = getRowDataWithMaxCountsForVirtualConnectionWithTagFilter;
//# sourceMappingURL=VirtualConnectionRowDataFunctions.js.map